import axiosInstance from "@/middleware/axios-wrapper";

export function fetchRenewalDetails(utmTags) {
  const {
    policyNo,
    utmSource,
    utmMedium,
    utmCampaign,
    utmContent,
    utmTerm,
    schemes,
    certificateNo,
    resource,
  } = utmTags;
  const queryParams = [
    resource === "GROUP_RENEWAL_HEALTH_QUOTE"
      ? `policyKey=${policyNo}`
      : policyNo && `policyNo=${policyNo}`,
    utmSource && `utm_source=${utmSource}`,
    utmMedium && `utm_medium=${utmMedium}`,
    utmCampaign && `utm_campaign=${utmCampaign}`,
    utmContent && `utm_content=${utmContent}`,
    utmTerm && `utm_term=${utmTerm}`,
    schemes && `schemes=${schemes}`,
    certificateNo && `certificateNo=${certificateNo}`,
  ].filter(Boolean);

  const queryString = queryParams.length > 0 ? `?${queryParams.join("&")}` : "";

  const urlBase = "/renewal";
  let url;

  if (resource === "GROUP_RENEWAL_HEALTH_QUOTE") {
    url = `${urlBase}/group-health/quote${queryString}`;
  } else {
    url = `${urlBase}/health/quote${queryString}`;
  }
  return axiosInstance.get(url);
}
